import { api } from './ApiInstanceInjector'

export const RegisterApiService = {
  getUserIpAndCountry () {
    return api.get('https://ipinfo.io/json?token=01fba74acd7fbd').then((response) => {
      return response.data
    })
  }
}
